import produce from 'immer';
import get from 'lodash.get';
import { immerEnsurePath, immerSet } from './util';

const CLEAR = 'create/changes/CLEAR';
const REMOVE = 'create/changes/REMOVE';
const ADD = 'create/changes/ADD';

/* eslint-disable no-param-reassign, default-case, consistent-return */
export default produce((state, action) => {
  switch (action.type) {
    case ADD: {
      const [entityKey, propKey, value] = action.payload;
      immerSet(state, [entityKey, propKey], value);
      break;
    }
    case REMOVE: {
      const [entityKey, propKey] = action.payload;
      immerEnsurePath(state, [entityKey]);
      delete state[entityKey][propKey];
      break;
    }
    case CLEAR:
      state[action.payload] = {};
      break;
  }
}, {});
/* eslint-enable no-param-reassign, default-case, consistent-return */

export const selectChanges = entityKey => state => get(state, ['v2', 'changes', entityKey], null);
export const selectHasChanges = entityKey => state =>
  !!Object.keys(get(state, ['v2', 'changes', entityKey], {})).length;
export const addChange = (entityKey, key, value) => dispatch =>
  dispatch({
    type: ADD,
    payload: [entityKey, key, value],
  });
export const removeChange = (entityKey, propKey) => dispatch =>
  dispatch({
    type: REMOVE,
    payload: [entityKey, propKey],
  });
export const clearChanges = entityKey => dispatch =>
  dispatch({
    type: CLEAR,
    payload: entityKey,
  });
